export default {
  banner: 'שלום, נשמח לעזור',
  contact_form: {
    title: 'פתיחת קריאת שרות',
    submit: 'שלח פניה',
    confirmation: 'תודה על המשוב',
  },
};
